import React, { useEffect, useRef, useState } from 'react';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../../../components/SelectTwo';
import { WarehouseExpeditionDataForm } from '../../../../../../../app/models/WareHouseQuoteExpedition';
import { Depot } from '../../../../../../../app/models/Depot';
import { Place } from '../../../../../../../app/models/Place';
import { QuoteRouteSegment } from '../../../../../../../app/models/QuoteRouteSegment';
import { Currency } from '../../../../../../../app/models/Currency';
import { Unit } from '../../../../../../../app/models/Unit';
import useHandleErrorFields from '../../../../../../../hooks/useHandleErrorFields';
import { PackingType } from '../../../../../../../app/models/PackingType';
import { RouteSegment } from '../../../../../../../app/models/RouteSegment';

interface Props {
    expeditionDataForm: WarehouseExpeditionDataForm;
    setExpeditionDataForm: (data: WarehouseExpeditionDataForm) => void;
    depots: Depot[];
    origins: Place[];
    destinations: Place[];
    routeSegments: RouteSegment[];
    currencies: Currency[];
    packingTypes: PackingType[];
    units: Unit[];
    disableUpdate?: boolean;
    errorFields?: any;

}

const WarehouseExpeditionForm = ({
    expeditionDataForm,
    setExpeditionDataForm,
    depots,
    origins,
    destinations,
    routeSegments,
    currencies,
    units,
    packingTypes,
    disableUpdate = false,
    errorFields
}: Props) => {


    const [filteredRougeSegments, setFilteredRougeSegments] = useState<RouteSegment[]>([]);
    
    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const isInitialLoad = useRef(true);

    useEffect(() => {
        if (expeditionDataForm.origin_id && expeditionDataForm.destiny_id) {
            const filtered = routeSegments.filter(
                (s) =>
                    s.origin_id === expeditionDataForm.origin_id &&
                    s.destiny_id === expeditionDataForm.destiny_id
            );
            setFilteredRougeSegments(filtered);
            
            // Solo resetear route_segment_id si NO es la carga inicial
            if (!isInitialLoad.current) {
                const currentSegmentExists = filtered.some(
                    segment => segment.id === expeditionDataForm.route_segment_id
                );
                
                if (!currentSegmentExists) {
                    setExpeditionDataForm({
                        ...expeditionDataForm,
                        route_segment_id: null
                    });
                }
            } else {
                isInitialLoad.current = false;
            }
        } else {
            setFilteredRougeSegments([]);
            if (!isInitialLoad.current) {
                setExpeditionDataForm({
                    ...expeditionDataForm,
                    route_segment_id: null
                });
            }
        }
    }, [expeditionDataForm.origin_id, expeditionDataForm.destiny_id]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setExpeditionDataForm({ ...expeditionDataForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        setExpeditionDataForm({ ...expeditionDataForm, 
            [name]: value });
    };

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();


    return (
        <>
            {/* Almacén */}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Almacén</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="origin_id"
                        id="origin_id"
                        inputValue={expeditionDataForm.origin_id}
                        hasError={fieldHasError('origin_id') !== ''}
                        options={SelectTwoMapperOptions(origins, 'id', ['name'])}
                        onChange={(value:any) => 
                            handleChangeSelectTwo('origin_id', value.value)
                        }
                        placeholder="Seleccione origen"
                        onFocus={() => onFocusRemove('origin_id')}
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('origin_id')}
                    </div>
                </div>
                
            </div>

            {/* Origen */}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Destino</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="destiny_id"
                        id="destiny_id"
                        inputValue={expeditionDataForm.destiny_id}
                        hasError={fieldHasError('destiny_id') !== ''}
                        options={SelectTwoMapperOptions(destinations)}
                        onChange={(val) => handleChangeSelectTwo('destiny_id', val.value)}
                        placeholder="Seleccione destino"
                        disabled={disableUpdate}
                        onFocus={() => onFocusRemove('destiny_id')}

                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('destiny_id')}
                    </div>
                </div>
            </div>

            {/* Tramo */}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tramo</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="route_segment_id"
                        id="route_segment_id"
                        inputValue={expeditionDataForm.route_segment_id}
                        hasError={fieldHasError('route_segment_id') !== ''}
                        options={SelectTwoMapperOptions(filteredRougeSegments, 'id', ['name'])}
                        onChange={(val) => handleChangeSelectTwo('route_segment_id', val.value)}
                        placeholder="Seleccione tramo"
                        disabled={disableUpdate}
                        onFocus={() => onFocusRemove('route_segment_id')}

                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('route_segment_id')}
                    </div>
                </div>
            </div>
            {/* Tramo */}
            {/* Tipo de contenedor */}

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tipo contenedor</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="packing_type_id"
                        id="packing_type_id"
                        inputValue={expeditionDataForm.packing_type_id}
                        hasError={fieldHasError('packing_type_id') !== ''}
                        options={SelectTwoMapperOptions(packingTypes)}
                        onChange={(val) => handleChangeSelectTwo('packing_type_id', val.value)}
                        placeholder="Seleccione tipo de contenedor"
                        disabled={disableUpdate}
                        onFocus={() => onFocusRemove('packing_type_id')}

                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('packing_type_id')}
                    </div>
                </div>
            </div> 

        </>
    );
};

export default WarehouseExpeditionForm;
